import { last } from 'lodash';
import { table } from '../quizApp.style';
import MathParser from '../MathParser';

function ShowAnswers(props) {
  return (
    <div className="table-responsive">
      <table className={table}>
        <tbody>
          <tr>
            <th>Questions</th>
            <th>Correct Answer</th>
            <th>Selected Answer</th>
            <th>Result</th>
          </tr>
          {Object.entries(props.useranswers).map((value) => {
            let parsedValue;
            let rawStr = last(value);
            if (typeof rawStr === 'object') {
              parsedValue = rawStr;
            } else {
              try {
                parsedValue = JSON.parse(rawStr);
              } catch (e) {
                // If the payload is completely corrupted, gracefully fail rather than crashing the app
                parsedValue = { correctanswer: '', useranswer: '', question: '' };
              }
            }
            const realAnswer = String(parsedValue.correctanswer || '').replace('Spell', '').replace(/\$/g, '').replace(/\s+/g, '').trim().toLowerCase();
            const userAnswer = String(parsedValue.useranswer || '').replace('Spell', '').replace(/\$/g, '').replace(/\s+/g, '').trim().toLowerCase();
            return (
              <tr key={parsedValue.question}>
                <td><MathParser text={parsedValue.question} /></td>
                <td><MathParser text={parsedValue.correctanswer} /></td>
                <td><MathParser text={parsedValue.useranswer} /></td>
                <td>
                  {realAnswer === userAnswer ? (
                    <img height="40" width="40" src="../assets/pass.png" alt="pass" />
                  ) : (
                    <img height="40" width="40" src="../assets/fail.png" alt="fail" />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ShowAnswers;
